import { mkEntityIdCodec } from '@code-expert/mongo-ts/identity';
import type { eq, show } from '@code-expert/prelude';
import { adt, iots, string } from '@code-expert/prelude';
import { TaskId } from '/imports/domain';

//--------------------------------------------------------------------------------------------------

export const QuizSnapshotIdBrand = Symbol('QuizSnapshotId');
export const QuizSnapshotId = mkEntityIdCodec(QuizSnapshotIdBrand);
export type QuizSnapshotId = iots.TypeOf<typeof QuizSnapshotId>;

export const quizSnapshotIdEq: eq.Eq<QuizSnapshotId> = string.Eq;

//--------------------------------------------------------------------------------------------------

export const quizSnapshotTypeKeys = {
  manual: null,
  publish: null,
};

type QuizSnapshotType = keyof typeof quizSnapshotTypeKeys;

export const QuizSnapshot = iots.struct(
  {
    _id: QuizSnapshotId,
    taskId: TaskId,
    createdAt: iots.date,
    type: iots.keyof(quizSnapshotTypeKeys),
  },
  {
    name: iots.maxLengthString(80),
  },
);

export type QuizSnapshot = iots.TypeOf<typeof QuizSnapshot>;

export const foldQuizSnapshotType = adt.foldFromKeys(quizSnapshotTypeKeys);

export const showQuizSnapshotType: show.Show<QuizSnapshotType> = {
  show: foldQuizSnapshotType({
    manual: () => 'Manual snapshot',
    publish: () => 'Published',
  }),
};

//--------------------------------------------------------------------------------------------------
